// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_MarketCountryRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_MarketCountryRow — one country for the staff market panels.
 *
 * Produced by GET /subscriptions/admin/market-countries (D6): the country
 * list comes from the locations-service (localidades_model::buscaPaises),
 * annotated with the billing market verdict from MarketPolicy. The staff
 * plan/pack market panels consume this endpoint — they must never hardcode
 * a country or currency list.
 *
 *   id            — locations-service country id (nullable defensively).
 *   code          — uppercased locations-service Code. '' when the source
 *                   datum is broken — such a country simply comes back
 *                   billing_ready=false (no synthetic fallback here; fixing
 *                   the datum belongs to the locations-service, A1). Chile
 *                   shipped like this and was fixed in dev on 2026-07-28 via
 *                   the locations-service's own save API (Code support added
 *                   to CountryInput); hml/prod still pending — runbook M3.
 *   name          — locations-service display name.
 *   billing_ready — MarketPolicy::isValidIso2(code) && isMarketCountry(code).
 *   currency      — MarketPolicy::primaryCurrencyForCountry(code); null when
 *                   the country has no billing market. The DEFAULT denomination
 *                   for display, not the only one that may be charged.
 *   currencies    — every currency this country may be billed in, primary
 *                   first (MarketPolicy::currenciesForCountry); [] for a
 *                   non-market country. Added 2026-09-08: a country stopped
 *                   having exactly one currency when CL/EC gained the BRL
 *                   ASAAS route, and the staff market panels filter countries
 *                   BY currency when authoring a price row — against
 *                   `currency` alone, Chile silently vanishes from the country
 *                   options of the very BRL row this change exists to allow.
 */
import { registerContract } from './validate'

export interface Subscriptions_MarketCountryRow {
id?: number
code?: string
name?: string
billing_ready?: boolean
currency?: string
currencies?: string[]
}

registerContract('Subscriptions_MarketCountryRow', {
  id:            { type: 'number',  required: false },
  code:          { type: 'string',  required: false },
  name:          { type: 'string',  required: false },
  billing_ready: { type: 'boolean', required: false },
  currency:      { type: 'string',  required: false },
  currencies:    { type: 'array',   required: false },
})
